/*
 * Polyfills
 */
import './polyfills/object-fit';

/*
 * Modules
 */

import './modules/init-sliders.js';
import './modules/init-bs-elements.js';
import './modules/handle-nav.js';
import './modules/init-aos.js';
import './modules/init-datepicker.js';
import './modules/handle-sticky-sidebar.js';
import './modules/init-select.js';
import './modules/filter-overlay';